import type { ScoringRules, UserAnswer, Question } from '@examflow/core';

/**
 * TOEFL 评分规则
 * TOEFL iBT 使用 0-120 分制
 */
export const toeflScoringRules: ScoringRules = {
  totalScore: 120,
  passingScore: 80,
  calculateScore: (answers: UserAnswer[], questions: Question[]): number => {
    if (questions.length === 0) return 0;

    const correctCount = answers.filter((a) => a.isCorrect).length;
    const accuracy = correctCount / questions.length;

    const score = Math.round(accuracy * 120);

    return Math.min(120, Math.max(0, score));
  },
};
